import http from "../../utils/http";

// 커뮤니티 목록
export const getCommunityList = () => {
  return new Promise((resolve, reject) => {
    http
      .get(`/community/list`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 커뮤니티 상세
export const getCommunity = (communityIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/community/${communityIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 커뮤니티 생성
export const addCommunity = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/community`, { ...params })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 커뮤니티 수정
export const putCommunity = (communityIdx, params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/community/${communityIdx}`, { ...params })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 커뮤니티 삭제
export const deleteCommunity = (communityIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/community/${communityIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};